var commerce = {};
module['exports'] = commerce;
commerce.color = require("./color");
commerce.department = require("./department");
commerce.product_name = require("./product_name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/commerce/index.js
// module id = 1716
// module chunks = 0